interface TopBarProps {
  userEmail?: string;
  onSignOut?: () => void;
}

export function TopBar({ userEmail, onSignOut }: TopBarProps) {
  return (
    <header className="flex h-14 items-center justify-between border-b border-line-1 bg-paper-0/80 px-6 backdrop-blur">
      <div />
      <div className="flex items-center gap-4">
        {userEmail ? <span className="font-mono text-ui text-ink-2">{userEmail}</span> : null}
        {onSignOut ? (
          <button
            type="button"
            onClick={onSignOut}
            className="rounded-token-md px-3 py-1.5 text-ui text-ink-1 transition-colors duration-2 ease-brand hover:bg-paper-2 focus-visible:shadow-focus focus-visible:outline-none"
          >
            Log ud
          </button>
        ) : null}
      </div>
    </header>
  );
}
